module.exports = __webpack_public_path__ + "img/IMG_1539_L_BlackMatted_MockedUp.c8d36691.jpg";